/**
 * The tabbed mega menu.
 *
 * Switches which group's grid of pictures is showing. Hover as well as click,
 * because a pointer already travelling down the rail should not have to stop
 * and press; click and keyboard focus for everyone else.
 *
 * The stylesheet shows the first panel and hides the others, so a menu whose
 * script has not arrived opens on one group instead of stacking all of them.
 * This only moves which one is showing.
 */
(function () {
  'use strict';

  function setup(root) {
    if (root.__tcMegaReady) return;
    var tabs = root.querySelectorAll('[data-tc-mtab]');
    var panels = root.querySelectorAll('[data-tc-mpanel]');
    if (!tabs.length || !panels.length) return;
    root.__tcMegaReady = true;

    function show(which) {
      for (var i = 0; i < panels.length; i++) {
        /* A class, not the hidden attribute: the stylesheet already shows the
           first panel and hides the rest, and `hidden` would fight it. */
        panels[i].classList.toggle('is-on', panels[i].getAttribute('data-tc-mpanel') === which);
      }
      for (var j = 0; j < tabs.length; j++) {
        var on = tabs[j].getAttribute('data-tc-mtab') === which;
        tabs[j].classList.toggle('is-on', on);
        tabs[j].setAttribute('aria-selected', on ? 'true' : 'false');
      }
    }

    for (var k = 0; k < tabs.length; k++) {
      var pick = function (e) { show(e.currentTarget.getAttribute('data-tc-mtab')); };
      tabs[k].addEventListener('mouseenter', pick);
      tabs[k].addEventListener('focus', pick);
      tabs[k].addEventListener('click', function (e) { e.preventDefault(); pick(e); });
    }

    /* The panels are display:none until the menu opens, and a lazy image
       inside a hidden element never loads — so the first hover showed a grid
       of empty tiles, and so did every tab switch. Nothing is fetched until
       the customer opens this menu; then everything in it is fetched at once,
       rather than 30-odd pictures on every page load. */
    var host = root.closest('.navigation__item') || root;
    var warm = function () {
      var imgs = root.querySelectorAll('img[loading="lazy"]');
      for (var i = 0; i < imgs.length; i++) imgs[i].loading = 'eager';
      fill(root);
      host.removeEventListener('mouseenter', warm);
      host.removeEventListener('focusin', warm);
    };
    host.addEventListener('mouseenter', warm);
    host.addEventListener('focusin', warm);

    root.setAttribute('data-tc-ready', 'on');
    show(tabs[0].getAttribute('data-tc-mtab'));
  }


  /**
   * Tiles with no picture: a menu link pointing at a vendor search rather than
   * a collection, which Liquid cannot read. The products exist, so ask the
   * shop's own predictive search for one and use its photograph.
   *
   * Only for tiles the server could not fill, only once per brand per tab, and
   * silent on failure — a menu must not depend on this working.
   */
  function fill(root) {
    var cards = root.querySelectorAll('[data-tc-fill]');
    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        var name = card.getAttribute('data-tc-fill');
        var fig = card.querySelector('.tc-mega__card-fig');
        if (!name || !fig || fig.querySelector('img')) return;
        card.removeAttribute('data-tc-fill');

        var key = 'tcMega:' + name;
        var cached = null;
        try { cached = sessionStorage.getItem(key); } catch (e) { /* private mode */ }
        if (cached) { paint(fig, cached, name); return; }

        var url = '/search/suggest.json?q=' + encodeURIComponent('vendor:"' + name + '"') +
                  '&resources[type]=product&resources[limit]=4';
        fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            var list = data && data.resources && data.resources.results &&
                       data.resources.results.products;
            if (!list || !list.length) return;
            for (var j = 0; j < list.length; j++) {
              var img = list[j].featured_image;
              if (img && img.url) {
                try { sessionStorage.setItem(key, img.url); } catch (e) { /* ignore */ }
                paint(fig, img.url, name);
                return;
              }
            }
          })
          .catch(function () { /* the tile simply stays as it was */ });
      })(cards[i]);
    }
  }

  function paint(fig, url, alt) {
    var img = new Image();
    img.loading = 'eager';
    img.alt = alt;
    img.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=320';
    fig.appendChild(img);
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-tc-mega]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* The header is a section, so the editor re-renders it on every edit. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
